import React from "react";
import { toast, ToastContent, ToastOptions } from "react-toastify";

import { WarningTriangle } from "~/ui-kit/icons/WarningTriangle";

export type ErrorToastProps = {
  message: ToastContent;
} & Pick<
  ToastOptions,
  "autoClose" | "closeButton" | "toastId" | "closeOnClick"
>;

export const ErrorToast = ({
  message,
  toastId,
  closeButton = true,
  autoClose = false,
  closeOnClick = false,
}: ErrorToastProps) =>
  toast.error(message, {
    icon: <WarningTriangle />,
    position: "top-center",
    theme: "dark",
    hideProgressBar: true,
    autoClose,
    draggable: false,
    closeButton,
    toastId,
    closeOnClick,
  });
